module.exports = __webpack_public_path__ + "img/insta.2fe2e470.svg";